import { PriceListFragment } from '../../../../../types';

export const getFilter = (prices?: PriceListFragment['prices']) => {
  const initialFilter = {
    hasInternationalPrices: false,
    hasUsedProducts: false,
    hasNotInMintCondition: false,
    hasPickupOnly: false,
    hasUnavailable: false,
    hasFilter: false,
  };
  if (!prices || !prices.nodes) {
    return initialFilter;
  }

  const hasInternationalPrices = prices.nodes.some(
    p => p && p.store && p.store.market !== 'primary'
  );
  const hasUsedProducts = prices.nodes.some(
    p => p && p.type === 'used_product'
  );
  const hasNotInMintCondition = prices.nodes.some(
    p => p && p.type === 'not_in_mint_condition'
  );
  const hasPickupOnly = prices.nodes.some(p => p && p.type === 'pickup_only');
  const hasUnavailable = prices.nodes.some(
    p => p && p.type === 'not_available_for_purchase'
  );

  const hasFilter =
    hasInternationalPrices ||
    hasUsedProducts ||
    hasNotInMintCondition ||
    hasPickupOnly ||
    hasUnavailable;

  return {
    hasInternationalPrices,
    hasUsedProducts,
    hasNotInMintCondition,
    hasPickupOnly,
    hasUnavailable,
    hasFilter,
  };
};
